/**
 * Spec §3.5: when the guest opens the invite link, FE pre-flight checks
 * cohostUids.length against the effective cap. Null cap means the cap is
 * unknown / solo — the blocker does not fire.
 */
export function isCohostSlotFull(currentCohostCount: number, effectiveCap: number | null): boolean {
  if (effectiveCap == null) return false;
  return currentCohostCount >= effectiveCap;
}
